import React, { useContext, useEffect, useState } from 'react';

import editBlue from 'assets/images/edit-blue.png';
import { Button, Upload, UploadFile, UploadProps } from 'antd';
import InputBorderNone from '../../../../../components/BorrowerTask/components/Atoms/Inputs/InputBorderNone/InputBorderNone';
import { useGetLatestLoanDocs } from '../../../../../services/ownership/querys';
import { useCreateLoanDoc } from '../../../../../services/loan/mutations';
import { ReplicationStrategy } from '../../../../../gql/graphql';

interface Props {
  reportKey: string;
  title: string;
  borrower: any;
  isCreditScore?: boolean;
  buttons: { download: string, upload: string };
}

const CardReport = ({ reportKey, title, borrower, isCreditScore, buttons }: Props) => {

  const { data: ownershipLatestDocuments, reexecute: getLatestDocuments } = useGetLatestLoanDocs({ 
    variables: { ownershipId: borrower._id },
    pause: true
  });
  const { execute: createLoanDoc, fetching } = useCreateLoanDoc();
  
  const [report, setReport] = useState<UploadFile>();
  const [isEdit, setEdit] = useState(false);
  const [creditScore, setCreditScore] = useState<string | null>(null);
  const [expire, setExpire] = useState<Date | null>(null);
  const [ordered, setOrdered] = useState<Date | null>(null);
  const [cardReport, setCardReport] = useState<any>();

  useEffect(() => {
    getLatestDocuments({ requestPolicy: 'network-only' });
  }, []);

  useEffect(() => {
    if (ordered && isEdit) {
      const newDate = new Date(ordered);
      newDate.setDate(newDate.getDate() + 90);
      setExpire(newDate);
    }
  }, [ordered]);

  useEffect(() => {
    const typeDocument = reportKey === 'credit_score' ? 'Credit Report' : 'Background Check';
    const cardReport = ownershipLatestDocuments?.find((document: any) => document.name.includes(typeDocument));
    if (cardReport) {
      setCardReport(cardReport);
      setCreditScore(cardReport?.metadata?.creditScore ?? null);
      setOrdered(cardReport?.metadata?.orderedDate ? new Date(cardReport?.metadata?.orderedDate) : null);
      setExpire(cardReport?.metadata?.expiryDate ?? null);
    }
  }, [ownershipLatestDocuments]);

  const onClickEdit = async () => {
    const payload: any = {
      _id: cardReport?._id,
      loan: cardReport?.loan?._id,
      file: report,
      replicationStrategy: ReplicationStrategy.CopyToAll,
    }
    if (isEdit && isCreditScore) {
      payload.metadata = {
        creditScore,
        expiryDate: expire,
        orderedDate: ordered
      }
    }
    await createLoanDoc(payload);
    getLatestDocuments({ requestPolicy: 'network-only' });
    setReport(undefined);
    
    setEdit(!isEdit);
  }

  const props: UploadProps = {
    beforeUpload: (file) => {
      setReport(file);
      setEdit(true);
      return false;
    },
    maxCount: 1,
    showUploadList: false,
    accept: 'application/pdf,image/*',
  };

  return (
    <div className='card-profile-generic card-report' style={{ paddingTop: isCreditScore? 30: 16 }}>
      <div className='card-report-head'>
        <h1 className='card-title'>{title}</h1>
        {isCreditScore &&
          <>
            {isEdit && 
              <InputBorderNone 
                type="number" 
                placeholder="Credit score" 
                color="bold-lith" 
                className="credit-score-input credit-score-input-text" 
                defaultValue={cardReport?.metadata?.creditScore}
                onChange={(v: any) => setCreditScore(v != null ? String(v) : null)}
              />
            }
            {!isEdit && <h1 className='card-title'>{cardReport?.metadata?.creditScore}</h1> }
          </>
        }
      </div>
      <div className='flex-btw mt-10'>
        {cardReport?.file && 
          <Button className="button button-submit" style={{ height: 40 }} onClick={() => window.open(cardReport?.file?.url, '_blank')}>
            {buttons.download}
          </Button>
        }
      </div>
      <div className='flex-btw mt-10'>
        {isEdit && isCreditScore && 
          <InputBorderNone 
            type="edit-date" 
            placeholder='' 
            color="bold-lith"
            value={ordered}
            onChange={(date: Date) => setOrdered(date)}
          />
        }
        {!isEdit && isCreditScore && (
          <span className='date-expires'>
            Ordered {ordered ? new Date(ordered).toLocaleDateString('en-US') : 'N/A'}
            </span>
          )}
        
        {isCreditScore && (
          <span className='date-expires'>
            Expiry {expire ? new Date(expire).toLocaleDateString('en-US') : 'N/A'}
          </span>
        )}
        <Upload
            name="report"
            className="upload-report"
            {...props}
          >
            <span className='button button-link-blue upload-report-span'>{report?.name || buttons.upload}</span>
          </Upload>
      </div>

      <Button className='button button-transparent button-edit' onClick={onClickEdit}>
        <img src={editBlue} className='edit' alt='edit' />
        {isEdit ? 'SAVE' : 'EDIT'}
      </Button>
    </div>
  )
}

export default CardReport;